import type { FC } from 'react';
import { LoginForm } from '../../features/login';

interface Props {
  isLocationRevoked: boolean;
}

// The Card chrome now lives in `LoginForm` so it can swap the whole card for the inline step UIs
// (which own their own Cards) without nesting. Any `returnUrl` stays in the `/login` URL query.
export const LoginView: FC<Props> = ({ isLocationRevoked }) => <LoginForm isLocationRevoked={isLocationRevoked} />;
